import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FC } from "react";
import Marquee from "react-fast-marquee";
import { Colors } from "../../../../configs";

export interface IMarqueeProps {
  text: string;
  maxWidth?: string;
}

const BG = "#F5F5F5";
const BORDER = "#E0E0E0";

const CustomMarquee: FC<IMarqueeProps> = ({ text, maxWidth = "57.79rem" }) => {
  const isEmpty = !text || text.trim() === "";

  return (
    <Box
      sx={{
        height: "2.28rem",
        width: "100%",
        background: BG,
        borderRadius: "1.25rem",
        border: `1px solid ${BORDER}`,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        paddingLeft: "0.85rem",
        paddingRight: "0.5rem",
        boxSizing: "border-box",
        flexShrink: 0,
      }}
    >
      <InfoOutlinedIcon
        sx={{ color: Colors.PRIMARY, fontSize: "1rem", flexShrink: 0 }}
      />
      {isEmpty ? (
        <Typography
          sx={{
            fontSize: "0.85rem",
            color: Colors.PRIMARY,
            opacity: 0.45,
            lineHeight: 1,
            userSelect: "none",
          }}
        >
          No customer alerts
        </Typography>
      ) : (
        <Marquee
          gradient={true}
          gradientColor={BG}
          style={{
            width: `calc(${maxWidth} - 2rem)`,
            maxWidth: `calc(${maxWidth} - 2rem)`,
          }}
        >
          <Typography
            component="span"
            sx={{
              display: "inline-block",
              marginRight: "6rem",
              fontSize: "0.85rem",
              color: Colors.TEXT_GRAY_DARK,
              fontWeight: 500,
              lineHeight: 1,
            }}
          >
            {text}
          </Typography>
        </Marquee>
      )}
    </Box>
  );
};

export default CustomMarquee;
